#import "../fragments/saved-list-stub-fragment.graphql"

mutation CreateSavedFilter($input: FilterCreateInput!) {
    filterCreate(input: $input) {
        filter {
            ...SavedListStubFragment
            isUpdateable
            isImmutable
            creatorUser {
                name
                id
            }
        }
    }
}
